var cifBe = ["301 261", "<g fill='none'><path fill='#000' d='M.5.5h300v260H.5z'/><path fill='#FAE042' d='M100.5.5h100v260h-100z'/><path fill='#ED2939' d='M200.5.5h100v260h-100z'/></g>"];

export { cifBe };

